export default __webpack_public_path__ + "static/media/2022_05_23 - Puma0004_0270.3b68a1b7.jpg";